/**
* SurveyCompleteController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';SurveyCompleteController.$inject = ["$rootScope", "$http", "$q", "$analytics", "$stateParams", "gplansConf", "Authentication", "Profile", "Survey", "affilate", "$localStorage", "$window", "$state", "$timeout", "plansResolved", "uid", "mesSystem", "MeasurementSystem", "currency", "$document", "UserService"];

  angular.
  module('gplans.survey.controllers').
  controller('SurveyCompleteController', SurveyCompleteController);

  SurveyCompleteController.$inject = ['$rootScope', '$http', '$q', '$analytics', '$stateParams', 'gplansConf', 'Authentication',
  'Profile', 'Survey', 'affilate', '$localStorage', '$window', '$state', '$timeout', 'plansResolved', 'uid', 'mesSystem', 'MeasurementSystem',
  'currency', '$document', 'UserService'];

  /**
                                           * @namespace SurveyCompleteController
                                           */
  function SurveyCompleteController($rootScope, $http, $q, $analytics, $stateParams, gplansConf, Authentication, Profile, Survey,
  affilate, $localStorage, $window, $state, $timeout, plansResolved, uid, mesSystem, MeasurementSystem,
  currency, $document, UserService) {
    $rootScope.pageTitle = 'Survey Complete';
    var vm = this;
    vm.linkClicked = linkClicked;
    vm.seeMyPlanButtonDisabled = !$localStorage.vidSeen;
    vm.seeMyPlanButtonClick = seeMyPlanButtonClick;
    vm.mesSystem = mesSystem;
    var _plansIds = {};
    var _plansFlowIds = {};

    activate();

    function activate() {
      vm.user = UserService.data;
      vm.looseWeight = UserService.data.current_weight - UserService.data.goal_weight;
      vm.goalWeight = UserService.data.goal_weight;
      if (mesSystem == 'SI') {
        vm.weightUnit = 'kg';
        vm.looseWeight = Math.round(MeasurementSystem.convertLbsToKg(vm.looseWeight));
        vm.goalWeight = Math.round(MeasurementSystem.convertLbsToKg(vm.goalWeight));
      } else
      {
        vm.weightUnit = 'pounds';
      }
      if (currency == 'GBP') {
        vm.currencySymbol = '£';
        vm.proCost = 29.99;
      } else
      if (currency == 'AUD' || currency == 'CAD') {
        vm.currencySymbol = currency + '$';
        vm.proCost = 49.99;
      } else
      {
        vm.proCost = 39.99;
      }
      /// used to be able to go directly to payment page
      if (currency == 'USD') vm.currencyToPlan = '';else
      vm.currencyToPlan = '-' + currency.toLowerCase();

      /////// Marketing tracking
      // todo: this piece is dublicated in store controller. move to $analytics prob, this's importaint to send early, so maybe move to quiz start
      if (affilate) {
        var props = {};
        for (var key in affilate) {
          if (affilate.hasOwnProperty(key)) {
            props['Affilate_' + key] = affilate[key];
          }
        }
        $analytics.setUserProperties(props);

        window.ga('set', 'dimension1', affilate['type']);
        window.ga('set', 'dimension2', affilate['hop'] || affilate['affid']);
      }

      // todo: this piece similar to previous (sending affilate params).
      // todo: Should remain here probably, as offer id may be changed in SurveyCompleteByOfferIdController
      // todo: we also set offerId misc so it'll be sent to Chartmogul for stats later
      if ($window.localStorage.offerId) {
        var props = {
          'offer_id': $window.localStorage.offerId };

        $analytics.setUserProperties(props);

        window.ga('set', 'dimension3', $window.localStorage.offerId);

        if ($window.heap && angular.isFunction($window.heap.addUserProperties)) {
          heap.addUserProperties({ 'offerId': $window.localStorage.offerId });
        }

        Profile.updateMisc({ key: 'offerId', value: $window.localStorage.offerId }).
        then(function (res) {
          // console.log(res);
        }, function () {
          Profile.createMisc({ key: 'offerId', value: $window.localStorage.offerId });
        });

        // activate optimize test
        if (!$window.localStorage.optimizeActivated && $window.dataLayer && angular.isFunction($window.dataLayer.push)) {
          setTimeout(function () {
            dataLayer.push({ 'event': 'optimize.activate' });
            $window.localStorage.optimizeActivated = 1;
          }, 1);
        }
      }

      /////// END Marketing tracking

      if (affilate && affilate.type === 'Clickbank') {
        vm.clickbank = true;
        if (!$rootScope.clickbankBadgeInstalled) {
          //  <!-- ClickBank Trust Badge -->
          $("<script>").attr({ src: '//cbtb.clickbank.net/?vendor=gplans' }).appendTo("body");
          $rootScope.clickbankBadgeInstalled = true;
        }
      }

      plansResolved.data.forEach(function (plan) {
        _plansIds[plan.slug] = plan.clickbank_item;
        _plansFlowIds[plan.slug] = plan.clickbank_flow_id;
      });

      $analytics.eventTrack('Survey Complete');

      var FBPixelEnrich = function FBPixelEnrich() {
        if (angular.isFunction($window.fbq)) {
          var metabolicTypeName = vm.metabolic_type ? vm.metabolic_type.name : 'None';
          $window.fbq('track', 'InitiateCheckout', {
            metabolicType: metabolicTypeName });

        }
      };

      var afterAuth = function afterAuth() {
        vm.gender = UserService.data.gender;

        if ($localStorage.bloodTypeResult && $localStorage.bloodTypeResult.id) {
          vm.metabolic_type = $localStorage.bloodTypeResult;
          vm.problems = {};
          FBPixelEnrich();
        } else {
          fetchUserSurvey().then(function () {
            FBPixelEnrich();
          });
        }
      };

      if (!Authentication.isAuthenticated()) {
        Authentication.check().then(function () {
          afterAuth();
        });
      } else {
        afterAuth();
      }

      var howLong = 180000; // 3 mins
      $timeout(function () {
        $localStorage.vidSeen = true;
        vm.seeMyPlanButtonDisabled = false;
      }, howLong);

      // $window.addEventListener('scroll',onWindowScroll);

      if (!$window.localStorage.offerId) {
        asyncLoadingScripts();
      }
    }

    function asyncLoadingScripts() {
      var Loader = function Loader() {};
      Loader.prototype = {
        require: function require(scripts, callback) {
          this.loadCount = 0;
          this.totalRequired = scripts.length;
          this.callback = callback;

          for (var i = 0; i < scripts.length; i++) {
            this.writeScript(scripts[i]);
          }
        },
        loaded: function loaded(evt) {
          this.loadCount++;

          if (this.loadCount == this.totalRequired && typeof this.callback == 'function') this.callback.call();
        },
        writeScript: function writeScript(src) {
          var self = this;
          var s = document.createElement('script');
          s.type = "text/javascript";
          s.async = true;
          s.src = src;
          s.addEventListener('load', function (e) {self.loaded(e);}, false);
          var head = document.getElementsByTagName('head')[0];
          head.appendChild(s);
        } };


      var l = new Loader();
      l.require([
      "https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.5/ScrollMagic.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/velocity/1.5.1/velocity.min.js"],


      function () {
        // Callback

        var currentId = null;
        var controller = new ScrollMagic.Controller({ container: '.main-layout__content' }); //addIndicators: true

        $('.main-layout__navigation__list_link').click(function (e) {
          $('.main-layout__navigation__list_link').removeClass('is-active');
          $(this).addClass('is-active');
          var id = $(this).attr('href');
          if ($(id).length > 0 && currentId !== id) {
            currentId = id;
            $(id).velocity("scroll",
            {
              container: $(".main-layout__content"),
              duration: 300 });


          }
        });

        $('.main-layout__navigation__list_link').each(function () {
          var self = this;
          var id = $(this).attr('href');
          if ($(id).length > 0) {
            new ScrollMagic.Scene({ duration: $(id).height(), triggerHook: 0.15, triggerElement: id }).
            setClassToggle(self, "is-active").
            addTo(controller);
          }
        });
      });
    }

    function randomIntFromInterval(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    }

    var gaugeMin = 58,gaugeMax = 74,gaugeDefault = 65;
    vm.gaugeNumber = gaugeDefault;

    function _setGaugeNumber(arr) {
      var diff = gaugeMax - gaugeMin;
      var result = gaugeDefault - gaugeMin;
      for (var idx in arr) {
        if (angular.isNumber(arr[idx])) {
          result += arr[idx];
        }
      }

      return gaugeMin + result % diff;
    }

    function fetchUserSurvey() {
      // todo: move to Survey Service
      return $http.get(gplansConf.API_URL + '/api/v1/usersurveys/' + $stateParams.userSurvey + '/').then(function (data) {
        vm.usersurvey = data.data;

        // todo: this one below is same as in store.controller.js, should be encapsulated somehow
        vm.problems = {};
        var metaPromise =
        $http.get(gplansConf.API_URL + '/api/v1/metabolictypes/' + UserService.data.last_checkin.metabolic_type + '/');
        var surveyPromise =
        Survey.getAnswers(vm.usersurvey.id);
        return $q.all([
        metaPromise,
        surveyPromise]).
        then(function (res) {
          vm.metabolic_type = res[0].data;

          vm.userSurveyAnswers = res[1].userSurveyAnswers;

          // better gauge number function
          vm.gaugeNumber = _setGaugeNumber(vm.userSurveyAnswers);
          console.log("Gauge: " + vm.gaugeNumber);

          vm.problems = res[1].problems;

          if (vm.problems['restrictions']) {
            if (vm.problems['restrictions'].indexOf('paleo') > -1) {
              vm.restrictionTitle = 'Paleo Diet';
            }
            if (vm.problems['restrictions'].indexOf('vegan') > -1) {
              vm.restrictionTitle = 'Vegan Diet';
            }
            if (vm.problems['restrictions'].indexOf('vegetarian') > -1) {
              vm.restrictionTitle = 'Vegetarian Diet';
            }
            if (vm.problems['restrictions'].indexOf('pescetarian') > -1) {
              vm.restrictionTitle = 'Pescetarian Diet';
            }
          }

          vm.showProblemsBlock = vm.problems['energy'] === 'low energy' ||
          vm.problems['mood'] === 'mood swings' ||
          vm.problems['heart'] === 'heart disease' ||
          vm.problems['diabetes'] === 'diabetes' ||
          vm.problems['stomach'] === 'stomach discomfort' || vm.problems['restrictions'];

          if (vm.restrictionTitle) {
            vm.metabolicTitle = vm.metabolic_type.name + ' (' + vm.restrictionTitle + ')';
          } else {
            vm.metabolicTitle = vm.metabolic_type.name;
          }
        });
      }, function (err) {
        // go to start of survey if error
        // location.href='/';
        $state.go('base.survey_start');
      });
    }

    var _errorSent = {}; // save already sent errors not to hit Sentry limits.
    function clickbankLink(plan) {
      if (!_plansIds[plan] && !_errorSent[plan])
      try {
        Raven.captureException(new Error('No Clickbank Item For Plan: ' + plan));
        _errorSent[plan] = true;
      } catch (e) {
        console.log(e.message);
      }


      var url = 'http://' + (_plansIds[plan] ? _plansIds[plan] : 'noitem') + '.gplans.pay.clickbank.net/?cbskin=14999';
      url += _plansFlowIds[plan] ? '&cbfid=' + _plansFlowIds[plan] : ''; // clickbank flow id for product
      url += '&uid=' + uid;

      return url;
    }

    // TODO: DRY refactor - same as in store.controller
    function linkClicked(plan) {
      var props = {};
      props['Plan ' + plan + ' Select'] = 'Plan ' + plan;
      // $analytics.eventTrack('Get Plan Click', props);
      $localStorage['plan'] = plan;

      if (vm.clickbank) {
        $window.location.href = clickbankLink(plan);
      } else {
        $state.go('base.store_payment', { plan: plan });
      }
    }

    function seeMyPlanButtonClick() {
      if (!vm.seeMyPlanButtonDisabled) {
        $state.go('base.store');
      }
    }

    /**
       * Log events when user scrolls page to defined values in percent.
       * Each event logs just once per page load.
       */
    function onWindowScroll() {
      var scrollPercent = $document.scrollTop() / (($document.outerHeight() - document.documentElement.clientHeight) / 100);
      var conditions = onWindowScroll.conditions || (onWindowScroll.conditions = [
      new Number(25),
      new Number(50),
      new Number(75),
      new Number(90)]);


      var calculatedCondition = function () {
        if (scrollPercent >= conditions[0] && scrollPercent < conditions[1]) {
          return conditions[0];
        } else if (scrollPercent >= conditions[1] && scrollPercent < conditions[2]) {
          return conditions[1];
        } else if (scrollPercent >= conditions[2] && scrollPercent < conditions[3]) {
          return conditions[2];
        } else if (scrollPercent >= conditions[3]) {
          return conditions[3];
        }
      }();

      if (!calculatedCondition) return;

      if (+onWindowScroll.currentCondition !== +calculatedCondition && !calculatedCondition.logged) {
        calculatedCondition.logged = true;
        onWindowScroll.currentCondition = calculatedCondition;
        var value = +calculatedCondition + '%';

        $analytics.eventTrack('VSL Scroll ' + value, { value: value });
        console.warn('scrolled to ', value);
      }
    }
  }
})();